import { Link } from "react-router-dom";
import GameCard from "../components/GameCard";

const games = [
  { id: "snake", title: "Snake Game" },
  { id: "movetac", title: "MoveTac" },
];

export default function Home() {
  return (
    <div>
      <h1>Jaude Games</h1>

      <div style={{ display: "flex", gap: "20px" }}>
        {games.map((game) => (
          <Link key={game.id} to={`/games/${game.id}`}>
            <GameCard title={game.title} />
          </Link>
        ))}
      </div>
    </div>
  );
}
